import script from "./NoteBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoteBlock.vue?vue&type=script&setup=true&lang=ts"

import "./NoteBlock.vue?vue&type=style&index=0&id=2bf8c389&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf8c389"]])

export default __exports__